import { createApi } from '@reduxjs/toolkit/dist/query/react';

import serverRoutes from '@app/utils/server-routes';

import { ADSettingsObjectType } from '@app/interfaces/slices-types/user-settings-type';

import { baseQuery } from '../baseQuery';

export const userSynchronizationADApi = createApi({
  reducerPath: 'userSynchronizationADApi',
  tagTypes: ['ADSyncInfo'],
  baseQuery: baseQuery,
  endpoints: (build) => ({
    getADSyncInfo: build.query<ADSettingsObjectType, void>({
      query: () => ({
        url: serverRoutes.AD_synchronization,
      }),
      providesTags: ['ADSyncInfo'],
    }),
    configureADSync: build.mutation<
      ADSettingsObjectType,
      { period: number; filter: ADSettingsObjectType['filter'] }
    >({
      query: (body) => ({
        url: serverRoutes.AD_synchronization,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['ADSyncInfo'],
    }),
    enableADSync: build.mutation<ADSettingsObjectType, void>({
      query: () => ({
        url: serverRoutes.AD_synchronization_enable,
        method: 'PUT',
      }),
      invalidatesTags: ['ADSyncInfo'],
    }),
    disableADSync: build.mutation<ADSettingsObjectType, void>({
      query: () => ({
        url: serverRoutes.AD_synchronization_disable,
        method: 'PUT',
      }),
      invalidatesTags: ['ADSyncInfo'],
    }),
    forceADSync: build.mutation<ADSettingsObjectType, void>({
      query: () => ({
        url: serverRoutes.AD_synchronization_force,
        method: 'PUT',
      }),
      invalidatesTags: ['ADSyncInfo'],
    }),
  }),
});

export const {
  useGetADSyncInfoQuery,
  useLazyGetADSyncInfoQuery,
  useConfigureADSyncMutation,
  useEnableADSyncMutation,
  useDisableADSyncMutation,
  useForceADSyncMutation,
} = userSynchronizationADApi;
